import styled from "styled-components";

import { StaticAssets } from "../styles/custom-assets";

/** The supplied cross, served from /static like the rest of the redesign's artwork. */
export const CloseIcon = styled.img.attrs({ src: StaticAssets.close, alt: "" })`
  width: 24px;
  height: 24px;
  display: block;
`;
